import React from "react";
import { BookOpen, Github, ShieldCheck } from "lucide-react";
import { connectedSupport, countPhrase, learningSupport, relativeMoment, reviewingValue } from "./workspaceOverviewModel";

function Stage({ icon, label, value, support, attention = false }) {
  return (
    <div className="rr-stage">
      <span className="rr-stage-icon" aria-hidden="true">{icon}</span>
      <div>
        <p>{label}</p>
        <strong>{value}</strong>
        <small className={attention ? "is-attention" : undefined}>{support}</small>
      </div>
    </div>
  );
}

export default function WorkspacePipeline({ overview }) {
  const setup = overview?.setup || {};
  const brain = overview?.brain;
  const reviews = overview?.reviews;
  const when = relativeMoment(reviews?.lastReviewedAt);
  const learningValue = brain ? countPhrase(brain.activeRules, "product rule") : "Still loading";
  const protectSupport = reviews?.lastReviewedAt ? `Last review ${when.label}` : "No reviews yet";

  return (
    <section className="rr-pipeline" aria-label="Connected, learning, and reviewing">
      <Stage icon={<Github size={18} />} label="Connected" value={countPhrase(setup.repositoryCount, "codebase")} support={connectedSupport(setup)} />
      <span className="rr-pipeline-arrow" aria-hidden="true">→</span>
      <Stage
        icon={<BookOpen size={18} />}
        label="Learning"
        value={learningValue}
        support={learningSupport(brain)}
        attention={(brain?.pendingConfirmation || 0) > 0 || (brain?.openConflicts || 0) > 0}
      />
      <span className="rr-pipeline-arrow" aria-hidden="true">→</span>
      <Stage icon={<ShieldCheck size={18} />} label="Reviewing" value={reviewingValue(overview)} support={protectSupport} />
    </section>
  );
}
